<template>
  <div v-if="showBadge" :class="['badge', badgeType, 'text-uppercase me-auto']">
    {{ env.context }}
  </div>
</template>

<script setup>
import { computed } from 'vue'

const env = window.siteVars.env || {}
const showBadge = computed(() => env?.context && env?.context !== 'prod')
const badgeType = computed(() => {
  const badges = {
    dev: 'info',
    test: 'success',
    uat: 'warning',
  }
  return `text-bg-${badges[env?.context] || 'secondary'}`
})
</script>

<style scoped>

</style>
